import api from './api';

const d = (r) => r.data;
const MP = { headers: { 'Content-Type': 'multipart/form-data' } };  // shared axios instance defaults to JSON
const B = '/api/letter-engine';
export const lettersAPI = {
  meta: () => api.get(`${B}/meta`).then(d),
  dashboard: () => api.get(`${B}/dashboard`).then(d),
  templates: (params) => api.get(`${B}/templates`, { params }).then(d),
  template: (id) => api.get(`${B}/templates/${id}`).then(d),
  createTemplate: (body) => api.post(`${B}/templates`, body).then(d),
  createDocxTemplate: (fd) => api.post(`${B}/templates/docx`, fd, MP).then(d),
  addVersion: (id, body) => api.post(`${B}/templates/${id}/versions`, body).then(d),
  approveVersion: (id, v) => api.post(`${B}/templates/${id}/versions/${v}/approve`).then(d),
  setActive: (id, active) => api.put(`${B}/templates/${id}/active`, { active }).then(d),
  templatePreview: (id) => api.get(`${B}/templates/${id}/preview`, { responseType: 'blob' }).then(d),
  settings: () => api.get(`${B}/settings`).then(d),
  saveSettings: (body) => api.put(`${B}/settings`, body).then(d),
  saveLetterhead: (body) => api.put(`${B}/letterhead`, body).then(d),
  uploadLogo: (fd) => api.post(`${B}/letterhead/logo`, fd, MP).then(d),
  removeLogo: () => api.delete(`${B}/letterhead/logo`).then(d),
  samplePdf: () => api.get(`${B}/letterhead/sample.pdf`, { responseType: 'blob' }).then(d),
  brandingLogo: () => api.get(`${B}/branding/logo`, { responseType: 'blob' }).then(d),
  logo: () => api.get(`${B}/letterhead/logo`, { responseType: 'blob' }).then(d),
  signatories: () => api.get(`${B}/signatories`).then(d),
  saveSignatory: (uid, body) => api.put(`${B}/signatories/${uid}`, body).then(d),
  uploadSignature: (fd) => api.post(`${B}/signatories/me/signature`, fd, MP).then(d),
  entities: (cid) => api.get(`${B}/clients/${cid}/entities`).then(d),
  resolve: (body) => api.post(`${B}/letters/resolve`, body).then(d),
  create: (body) => api.post(`${B}/letters`, body).then(d),
  list: (params) => api.get(`${B}/letters`, { params }).then(d),
  get: (id) => api.get(`${B}/letters/${id}`).then(d),
  update: (id, body) => api.put(`${B}/letters/${id}`, body).then(d),
  addEvidence: (id, fd) => api.post(`${B}/letters/${id}/evidence`, fd, MP).then(d),
  declare: (id, keys) => api.put(`${B}/letters/${id}/declarations`, { keys }).then(d),
  previewBlob: (id) => api.get(`${B}/letters/${id}/preview.pdf`, { responseType: 'blob' }).then(d),
  finalBlob: (id) => api.get(`${B}/letters/${id}/pdf`, { responseType: 'blob' }).then(d),
  submit: (id) => api.post(`${B}/letters/${id}/submit`).then(d),
  approve: (id, note) => api.post(`${B}/letters/${id}/approve`, { note }).then(d),
  reject: (id, note) => api.post(`${B}/letters/${id}/reject`, { note }).then(d),
  override: (id, reason) => api.post(`${B}/letters/${id}/blocklist-override`, { reason }).then(d),
  issue: (id) => api.post(`${B}/letters/${id}/issue`).then(d),
  send: (id, body) => api.post(`${B}/letters/${id}/send`, body).then(d),
  manualSend: (id, fd) => api.post(`${B}/letters/${id}/manual-send`, fd, MP).then(d),
  publish: (id) => api.post(`${B}/letters/${id}/publish-portal`).then(d),
  myLetters: () => api.get(`${B}/my-letters`).then(d),
  myLetterBlob: (id) => api.get(`${B}/my-letters/${id}/pdf`, { responseType: 'blob' }).then(d),
};

export const LETTER_STATUS = {
  draft: ['Draft', 'bg-muted text-foreground'], pending_approval: ['Pending approval', 'bg-amber-100 text-amber-800'],
  approved: ['Approved – awaiting signature', 'bg-sky-100 text-sky-800'], issued: ['Issued', 'bg-emerald-100 text-emerald-800'],
  sent: ['Sent', 'bg-emerald-200 text-emerald-900'],
};
export const RISK_COLOR = { factual: 'bg-slate-100 text-slate-700', estimate: 'bg-amber-100 text-amber-800', 'opinion-restricted': 'bg-red-100 text-red-800' };
export const errText = (e) => { const x = e?.response?.data?.detail; return typeof x === 'string' ? x : x?.message || 'Something went wrong'; };
export const openBlob = (blob) => window.open(URL.createObjectURL(blob), '_blank', 'noopener');
